module.exports = __webpack_public_path__ + "static/media/perception.c8cadbdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainmenus/perception.png
// module id = 1078
// module chunks = 0